import React, { Component } from 'react'
import { unitProductOperationsService } from '../../_services/unitProductOperations.service'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { DecimalInput } from 'react-hichestan-numberinput'
import measurementTypes from '../../_constants/measurementTypes'
import Loading from '../Shared/Loading'
import ConvertQuantity from '../Shared/ConvertQuantity'

class ProductOperationsTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      // defaultValue: this.props.defaultValue || undefined,
      data: [],
      selected: [],
      dto: {
        brandId: this.props.brandId,
        categoryId: this.props.categoryId,
        unitId: this.props.unitId
      },
      finalList: []
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    if (this.state.dto.unitId) {
      this.setState({ loading: true })
      unitProductOperationsService
        .getAllProducts(JSON.stringify(this.state.dto))
        .then(res => {
          console.log(res.data)

          let data = res.data
          this.setState({ data: data, loading: false, isSubmitting: false })
        })
        .catch(error => {
          this.setState({ loading: false })
          // console.log(error)
        })
    }
  }

  async componentWillReceiveProps(nextProps) {
    let dto = this.state.dto

    // if (nextProps.defaultValue !== this.state.defaultValue) {
    //   this.setState({ defaultValue: nextProps.defaultValue });
    // }
    // if (nextProps.categoryId !== this.state.dto.categoryId) {
    //   dto["categoryId"] = nextProps.categoryId;
    //   // this.setState({ dto: dto, data: [] }, () => {
    //   //   this.getData();
    //   // });
    // }
    // if (nextProps.brandId !== this.state.dto.brandId) {
    //   dto["brandId"] = nextProps.brandId;
    //   // this.setState({ dto: dto, data: [] }, () => {
    //   //   this.getData();
    //   // });
    // }
    // if (nextProps.unitId !== this.state.dto.unitId) {
    //   dto["unitId"] = nextProps.unitId;
    // }

    if (nextProps.dto != undefined && nextProps.dto !== this.state.dto) {
      dto = nextProps.dto
      this.setState({ dto: dto, data: [] }, () => {
        this.getData()
      })
    }
  }

  handleQuantityChange = (e, unitProductId, conversionUnit) => {
    let quantity = e.target.value

    let subQuantity = undefined

    if (quantity != undefined && conversionUnit != undefined) {
      // subQuantity = Math.round(quantity / conversionUnit)
      subQuantity = Number((quantity / conversionUnit).toFixed(3))
    }

    let list = this.state.finalList

    let index = list.findIndex(el => el.unitProductId === unitProductId)

    if (index > -1) {
      list[index].quantity = quantity
      list[index].subQuantity = subQuantity
    } else {
      let obj = {}
      obj['unitProductId'] = unitProductId
      obj['quantity'] = quantity
      obj['subQuantity'] = subQuantity
      list.push(obj)
    }

    this.setState({ finalList: list }, () => {
      this.props.onChange(list)
    })
  }

  handleSubQuantityChange = (e, unitProductId, conversionUnit) => {
    let subQuantity = e.target.value

    let quantity = undefined

    if (subQuantity != undefined && conversionUnit != undefined) {
      // quantity = Math.round(subQuantity * conversionUnit)
      quantity = Number((subQuantity * conversionUnit).toFixed(3))
    }

    let list = this.state.finalList

    let index = list.findIndex(el => el.unitProductId === unitProductId)

    if (index > -1) {
      list[index].quantity = quantity
      list[index].subQuantity = subQuantity
    } else {
      let obj = {}
      obj['unitProductId'] = unitProductId
      obj['quantity'] = quantity
      obj['subQuantity'] = subQuantity
      list.push(obj)
    }

    this.setState({ finalList: list }, () => {
      this.props.onChange(list)
    })
  }

  handleDelete = unitProductId => {
    let finalList = this.state.finalList
    let data = this.state.data

    finalList = finalList.filter(el => el.unitProductId != unitProductId)
    data = data.filter(el => el.id != unitProductId)

    this.setState({ finalList: finalList, data: data }, () => {
      this.props.onChange(finalList)
    })
  }

  render() {
    const { data, loading, defaultValue, disabled, finalList } = this.state
    const { clearable, className, required } = this.props

    return (
      <div style={{ minHeight: 'calc(100vh - 390px)' }}>
        {/* <div className="table-responsive"> */}
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">موجودی فعلی (اصلی)</th>
              <th className="text-center">
                {this.props.unitProductOperationType === 0
                  ? 'مقدار وارد شده به انبار'
                  : 'مقدار خارج شده از انبار'}
              </th>
              <th className="text-center">واحد شمارش</th>
              <th className="text-center">موجودی فعلی (فرعی)</th>
              <th className="text-center">
                {this.props.unitProductOperationType === 0
                  ? 'مقدار وارد شده به انبار'
                  : 'مقدار خارج شده از انبار'}
              </th>
              <th className="text-center">واحد فرعی</th>
              <th className="text-center">حذف از لیست</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              data.map((item, index) => (
                <tr key={'product-item-' + index}>
                  <td>{index + 1}</td>
                  <td>{item.product.name}</td>
                  <td>{item.product.extraCode}</td>
                  <td>{item.product.category.name}</td>
                  <td>{item.product.brand.name}</td>
                  <td>{item.quantity}</td>
                  <td>
                    <DecimalInput
                      type="tel"
                      value={
                        finalList != undefined &&
                        finalList.filter(
                          el => el.unitProductId === item.id
                        )[0] != undefined &&
                        finalList.filter(el => el.unitProductId === item.id)[0]
                          .quantity
                      }
                      onChange={e => {
                        item.product.measurementType !== undefined
                          ? this.handleQuantityChange(
                              e,
                              item.id,
                              item.product.conversionUnit
                            )
                          : this.handleQuantityChange(e, item.id)
                      }}
                      className="text-input"
                    />
                  </td>
                  <td>
                    {item.product.measurementType !== undefined &&
                    measurementTypes.filter(
                      el => el.value === item.product.measurementType
                    )[0]
                      ? measurementTypes.filter(
                          el => el.value === item.product.measurementType
                        )[0].label
                      : '-'}
                  </td>
                  <td>
                    {item.product
                      ? ConvertQuantity(
                          item.quantity,
                          item.product.conversionUnit,
                          3,
                          2
                        )
                      : ''}
                  </td>
                  <td>
                    {item.product.subMeasurementType !== undefined &&
                    item.product.conversionUnit ? (
                      <DecimalInput
                        type="tel"
                        value={
                          finalList != undefined &&
                          finalList.filter(
                            el => el.unitProductId === item.id
                          )[0] != undefined &&
                          finalList.filter(
                            el => el.unitProductId === item.id
                          )[0].subQuantity
                        }
                        onChange={e => {
                          this.handleSubQuantityChange(
                            e,
                            item.id,
                            item.product.conversionUnit,
                            index
                          )
                        }}
                        className="text-input"
                      />
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {item.product.subMeasurementType !== undefined &&
                    measurementTypes.filter(
                      el => el.value === item.product.subMeasurementType
                    )[0]
                      ? measurementTypes.filter(
                          el => el.value === item.product.subMeasurementType
                        )[0].label
                      : '-'}
                  </td>
                  <td>
                    <a
                      onClick={() => this.handleDelete(item.id)}
                      className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn">
                      <IoIosCloseCircleOutline size="24px" />
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="11"
                  style={{
                    overflow: 'hidden',
                    height: 'calc(100vh - 350px)',
                    position: 'relative'
                  }}>
                  <Loading />
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* </div> */}
      </div>
    )
  }
}
export default ProductOperationsTable
